import { axiosInstance as axios } from '../../boot/axios'
import { axiosInstance as axiosAssembly } from '../../boot/axios-assembly'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    //快客案件追踪列表
    GetQuickOrderList({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetQuickOrderList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //工班订单詳情信息
    GetQuickOrderDTO({ rootGetters }, request) {
      return axios
        .get(`QuickCaseTracking/GetQuickOrderDTO?OrderId=${request.OrderId}&OemOrBusId=${request.OemOrBusId}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得Mes訂單報價資訊
    GetOemMesQuotation({ commit, rootGetters }, request) {
      return axios
        .get('OemCaseTracking/GetOemMesQuotation', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得Mes訂單報價資訊
    GetMesQuotationImage({ commit, rootGetters }, url) {
      return axios
        .get(url, { responseType: 'blob' })
        .then(async (response) => {
          // 透過blob.type判斷是否為stream，若否則將 blob 轉為 JSON
          const blob = response.data
          if (blob.type === 'application/json') {
            const text = await blob.text()
            const json = JSON.parse(text)

            if (json?.Values?.ReqInt === -1) {
              return Promise.reject(json?.Values?.errorInfo)
            } else {
              return Promise.reject('發生錯誤')
            }
          } else {
            return Promise.resolve(response)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得門店訂單報價資訊
    GetQuickQuotationImage({ commit, rootGetters }, url) {
      return axios
        .get(url, { responseType: 'blob' })
        .then(async (response) => {
          // 透過blob.type判斷是否為stream，若否則將 blob 轉為 JSON
          const blob = response.data
          if (blob.type === 'application/json') {
            const text = await blob.text()
            const json = JSON.parse(text)

            if (json?.Values?.ReqInt === -1) {
              return Promise.reject(json?.Values?.errorInfo)
            } else {
              return Promise.reject('發生錯誤')
            }
          } else {
            const res = {
              blob: response.data,
              fileName: response.headers['content-disposition']
            }
            return Promise.resolve(res)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得Mes訂單報價資訊
    GetMesOrdersByOemProcessedStatus({ commit, rootGetters }, request) {
      return axios
        .get('OemCaseTracking/GetMesOrdersByOemProcessedStatus', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得客戶資料的負責業務人員
    GetOrderClientByID({ commit, rootGetters }, request) {
      return axios
        .get('OemCaseTracking/GetOrderClientByID', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 上傳客戶回簽的報價單
    UploadMesQuotationSignBack({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('SourceDivide', request.SourceDivide)
      if (request.MesOrderID) {
        formData.append('MesOrderID', request.MesOrderID)
      } else {
        formData.append('OemOrderID', request.OemOrderID)
      }
      formData.append('UploadFile', request.File)

      return axios
        .post('OemCaseTracking/UploadMesQuotationSignBack', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 上傳客戶回簽的門店訂單
    UploadQuickQuotationSignBack({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('QuickID', request.QuickID)
      formData.append('UploadFile', request.File)

      return axios
        .post('QuickCaseTracking/UploadQuickQuotationSignBack', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //代工申请工班詳情信息
    GetOemOrderApplyAss({ rootGetters }, request) {
      return axios
        .get(`QuickCaseTracking/GetOemOrderApplyAss?OrderId=${request.OrderId}&OemOrBusId=${request.OemOrBusId}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //快客代工 新增 工班项目
    AddApplyAssemblyOrder({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/AddApplyAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //工班主管列表
    GetAssemblyManagerList({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetAssemblyManagerList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //新增或編輯 申請派車
    SetAssDispatchRecordsInfo({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/SetAssDispatchRecordsInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取 申請派車記錄Info
    GetAssDispatchRecordsInfo({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetAssDispatchRecordsInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //刪除 申請派車記錄
    DeleteDispatchRecordByID({ rootGetters }, Id) {
      return axios
        .delete('QuickCaseTracking/DeleteDispatchRecordByID', {
          params: { DispatchRecordID: Id }
        })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //添加工班项目
    AddAssemblyOrder({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/AddAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 工班司机和工班师傅获取列表
    GetAssemblyClerkList({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetAssemblyClerkList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 工班排程获取API
    GetWorkScheduleList({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetWorkScheduleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GTUTUploadFile({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)

      return axios
        .post(process.env.ASSEMBLY_FILE_URL + '/api/GTUTFile/GTUTUploadFile', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取快客柜业务主案件分配信息
    GetQuickAllocationCaseInfo({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetQuickAllocationCaseInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //认领快客柜业务订单
    SetQuickBusinessCaseInfo({ rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/SetQuickBusinessCaseInfo', {
          ...request
        })
        .then((response) => {
          if (!response.data.Values.RC) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //取消代工案件
    CancelOemOrder({ commit, rootGetters }, request) {
      return axios
        .put('OemCaseTracking/CancelOemOrder', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //取消代工訂單
    UnpickMesOrder({ commit, rootGetters }, request) {
      return axios
        .put('OemCaseTracking/UnpickMesOrder', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取代工挑拣主单案件信息
    GetOemMasterOrderCaseInfo({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetOemMasterOrderCaseInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //获取代工挑拣追加异况拆单案件信息
    GetOemOrderCaseInfo({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetOemOrderCaseInfo', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //代工确认挑拣案件POST
    PickMesOrder({ commit, rootGetters }, request) {
      return axios
        .put('OemCaseTracking/PickMesOrder', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //獲取申請列表
    GetCapacityReservationList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetCapacityReservationList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取板材列表料號
    GetBigBoardRawBoardSNList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetBigBoardRawBoardSNList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取板材列表顔色
    GetBigBoardColorList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetBigBoardColorList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取五金料號
    GetHardWareProductNumberList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetHardWareProductNumberList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取五金名稱
    GetHardWareMetalNameList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetHardWareMetalNameList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetCapacityReservation({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/SetCapacityReservation', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CapacityReservationDetails({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/CapacityReservationDetails', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AppointmentExamine({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/AppointmentExamine', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取審核列表
    GetCapacityReservationExamineList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetCapacityReservationExamineList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //獲取審核詳情
    CapacityReservationExamineDetails({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/CapacityReservationExamineDetails', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ExamineCapacityReservation({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/ExamineCapacityReservation', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetReservationOrderId({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/SetReservationOrderId', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddAbnormalAppend({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('OrderTitle', request.OrderTitle)
      formData.append('ManufacturerID', request.ManufacturerID)
      formData.append('OrderType', request.OrderType)
      formData.append('BusinessOrderId', request.BusinessOrderId)
      formData.append('AbnormalReason', request.AbnormalReason)
      formData.append('AbnormalDutyDep', request.AbnormalDutyDep)
      formData.append('AbnormalDutyPersonName', request.AbnormalDutyPersonName)
      formData.append('AbnormalApprovalDep', request.AbnormalApprovalDep)

      request.Demands.forEach((item, index) => {
        formData.append(`Demands[${index}].DemandTitle`, item.DemandTitle)
        formData.append(`Demands[${index}].DemandCount`, item.DemandCount)
        formData.append(`Demands[${index}].DemandRemark`, item.DemandRemark)
        formData.append(`Demands[${index}].DesignerNoteFile`, item.DesignerNoteFile)
        formData.append(`Demands[${index}].DesignSubOrderGuid`, item.DesignSubOrderGuid)
      })
      return axios
        .post('QuickCaseTracking/AddAbnormalAndDesignerModification', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddAbnormalAppendOem({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('OrderTitle', request.OrderTitle)
      formData.append('ManufacturerID', request.ManufacturerID)
      formData.append('OrderType', request.OrderType)
      formData.append('OemOrderID', request.OemOrderID)
      formData.append('AbnormalReason', request.AbnormalReason)
      formData.append('AbnormalDutyDep', request.AbnormalDutyDep)
      formData.append('AbnormalDutyPersonName', request.AbnormalDutyPersonName)
      formData.append('AbnormalApprovalDep', request.AbnormalApprovalDep)

      request.Demands.forEach((item, index) => {
        formData.append(`Demands[${index}].DemandTitle`, item.DemandTitle)
        formData.append(`Demands[${index}].DemandCount`, item.DemandCount)
        formData.append(`Demands[${index}].DemandRemark`, item.DemandRemark)
        formData.append(`Demands[${index}].DesignerNoteFile`, item.DesignerNoteFile)
        formData.append(`Demands[${index}].DesignSubOrderGuid`, item.DesignSubOrderGuid)
      })
      return axios
        .post('QuickCaseTracking/AddAbnormalAndDesignerModificationOem', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOemMesOrder({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('OrderTitle', request.OrderTitle)
      formData.append('ManufacturerID', request.ManufacturerID)
      formData.append('OrderType', request.OrderType)
      formData.append('OemOrderId', request.OemOrderId)
      request.Demands.forEach((item, index) => {
        formData.append(`Demands[${index}].DemandTitle`, item.DemandTitle)
        formData.append(`Demands[${index}].DemandCount`, item.DemandCount)
        formData.append(`Demands[${index}].DemandRemark`, item.DemandRemark)
        formData.append(`Demands[${index}].DesignerNoteFile`, item.DesignerNoteFile)
        formData.append(`Demands[${index}].DesignSubOrderGuid`, item.DesignSubOrderGuid)
      })
      return axios
        .post('QuickCaseTracking/AddOemMesOrder', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddMesProduceOrder({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('OrderTitle', request.OrderTitle)
      formData.append('ManufacturerID', request.ManufacturerID)
      formData.append('OrderType', request.OrderType)
      formData.append('StoreReplenishmentDetailId', request.StoreReplenishmentDetailId)
      request.Demands.forEach((item, index) => {
        formData.append(`Demands[${index}].DemandTitle`, item.DemandTitle)
        formData.append(`Demands[${index}].DemandCount`, item.DemandCount)
        formData.append(`Demands[${index}].DemandRemark`, item.DemandRemark)
        formData.append(`Demands[${index}].DesignerNoteFile`, item.DesignerNoteFile)
        formData.append(`Demands[${index}].DesignSubOrderGuid`, item.DesignSubOrderGuid)
      })
      return axios
        .post('QuickCaseTracking/AddMesProduceOrder', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickCaseDesignerList({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetQuickCaseDesignerList', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ApplyMaterialPreparation({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/ApplyMaterialPreparation', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetMetalCommonSortingList({ commit, rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetMetalCommonSortingList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    NewOrderEstimate({ commit, rootGetters }, request) {
      let data = new FormData()
      request.DesignSubOrderGuids.forEach((it) => {
        data.append('DesignSubOrderGuids', it)
      })
      data.append('ManufacturerID', request.ManufacturerID)
      data.append('IsContaineMetal', request.IsContaineMetal)
      return axios
        .post('NewOrderEstimate', data)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    QuickApplyCaseClosure({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/QuickApplyCaseClosure', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetCancelOemCaseClaim({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/SetCancelOemCaseClaim', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetCancelQuickCaseClaim({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/SetCancelQuickCaseClaim', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CancelQuickOrder({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/CancelQuickOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetAssemblyStatus({ commit, rootGetters }, request) {
      return axiosAssembly
        .post('SetAssemblyStatus', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    GetAssembleScheduleList({ commit, rootGetters }, request) {
      return axios
        .post('QuickCaseTracking/GetAssembleScheduleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOrderClientList({ commit, rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetOrderClientList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetBandingStripleList({ commit, rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetBandingStripleList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //外购品询价List接口
    GetOrderPurchaseGoodsInqueryList({ commit, rootGetters }, request) {
      return axios
        .post('OrderPurchaseGoodsInquery/GetOrderPurchaseGoodsInqueryList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 外购品处理导出Excel
    DownLoadPurchaseExcel({ rootGetters }, request) {
      return axios
        .post('OrderPurchaseGoodsInquery/DownLoadPurchaseExcel', { ...request }, { responseType: 'blob' })
        .then((response) => {
          if (response.data.Values && response.data.Values.ReqInt === -1) {
            return Promise.reject('發生錯誤')
          } else {
            return Promise.resolve(response.data)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOrderPurchaseGoodsInquery({ commit, rootGetters }, request) {
      return axios
        .post('OrderPurchaseGoodsInquery/AddOrderPurchaseGoodsInquery', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOrderPurchaseGoodsInquery({ commit, rootGetters }, request) {
      return axios
        .post('OrderPurchaseGoodsInquery/UpdateOrderPurchaseGoodsInquery', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    EditOrderPurchaseGoodsInquery({ commit, rootGetters }, request) {
      return axios
        .post('OrderPurchaseGoodsInquery/EditOrderPurchaseGoodsInquery', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOrderPurchaseGoodsInqueryById({ commit, rootGetters }, request) {
      return axios
        .get(
          `OrderPurchaseGoodsInquery/GetOrderPurchaseGoodsInqueryById?orderPurchaseGoodsInqueryId=${request.orderPurchaseGoodsInqueryId}`
        )
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOrderPurchaseGoodsInqueryByNumber({ commit, rootGetters }, request) {
      return axios
        .get(
          `OrderPurchaseGoodsInquery/GetOrderPurchaseGoodsInqueryByNumber?orderPurchaseGoodsInqueryNumber=${request.purchaseGoodsNumber}`
        )
        .then((response) => {
          if (response.data.Values.Data.ReqInt === 0) {
            return Promise.resolve(response.data.Values.Data)
          } else if (response.data.Values.Data.ReqInt === -1) {
            return Promise.reject(response.data.Values.Data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DownloadGrossMarin({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('EstimateId', request.EstimateId)
      return axios
        .post('DownloadGrossMarin', formData, { responseType: 'blob' })
        .then((response) => {
          if (response.data) {
            return Promise.resolve(response.data)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetPopCapacityDetails({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/GetPopCapacityDetails', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    OrderCaseTypeList({ rootGetters }, request) {
      return axios
        .post('CapacityReservation/OrderCaseTypeList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddCopyOemCase({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/AddCopyOemCase', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickERPList({ rootGetters }, request) {
      return axios
        .post('QuickCaseERP/GetQuickOrderList', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemOrderCaseList({ rootGetters }, request) {
      return axios
        .post('QuickCaseERP/GetOemOrderCaseList', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateQuickERP({ rootGetters }, request) {
      return axios
        .put('QuickCaseERP/UpdateQuickERP', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOemOrderCaseERP({ rootGetters }, request) {
      return axios
        .post('QuickCaseERP/UpdateOemOrderCaseERP', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    BatchDownloadQuotation({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/BatchDownloadQuotation', { ...request }, { responseType: 'blob' })
        .then(async (response) => {
          // 透過blob.type判斷是否為stream，若否則將 blob 轉為 JSON
          const blob = response.data
          if (blob.type === 'application/json') {
            const text = await blob.text()
            const json = JSON.parse(text)

            if (json?.Values?.ReqInt === -1) {
              return Promise.reject(json?.Values?.errorInfo)
            } else {
              return Promise.reject('發生錯誤')
            }
          } else if (blob.size < 100) {
            return Promise.reject('無資料')
          } else {
            // 擷取後端回傳檔案名稱及blob
            const res = {
              blob: response.data,
              fileName: response.headers['content-disposition']
            }

            return Promise.resolve(res)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
